import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { toast } from 'react-toastify';
import notify from 'Common/utils/notify';
import { WarningRounded } from '@material-ui/icons';
import markDriverLicenseAsLost from 'Measure/api/driver-license/update/markDriverLicenseAsLost';
import axios from 'axios';
import Modal from 'Common/components/Modals/Modal';
import Button from 'Common/components/Button';
import ModalTitle from 'Common/components/Modals/ModalTitle';
import WarningMessage from 'Common/components/Modals/WarningMessage';

const MarkButton = styled(Button)`
    width: 100%;
`;

const MarkAsLostButton = ({ driverLicenseControl }) => {
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpened, setIsModalOpened] = useState(false);

    const openModal = () => {
        setIsModalOpened(true);
    };

    const closeModal = () => {
        setIsModalOpened(false);
    };

    const source = useMemo(() => axios.CancelToken.source(), []);

    useEffect(
        () => () => {
            source.cancel();
        },
        [source],
    );

    const handleConfirmMarkAsLost = async () => {
        setIsLoading(true);

        try {
            await markDriverLicenseAsLost(
                driverLicenseControl.id,
                source.token,
            );

            notify(
                'Der Führerschein wurde als verloren markiert und deaktiviert',
                {
                    type: toast.TYPE.SUCCESS,
                },
            );

            dispatch(push('/measures/vehicles/driver-licenses'));
        } catch (error) {
            if (!axios.isCancel(error)) {
                notify(
                    'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
                    {
                        type: toast.TYPE.ERROR,
                    },
                );
            }
        }

        setIsLoading(false);
    };

    return (
        <>
            <MarkButton
                outline
                type="button"
                isLoading={isLoading}
                disabled={isLoading}
                onClick={openModal}
            >
                Führerscheinverlust
            </MarkButton>
            {isModalOpened && (
                <Modal
                    isOpen={isModalOpened}
                    onRequestClose={isLoading ? undefined : closeModal}
                    buttons={
                        <>
                            <Button
                                text
                                dark
                                type="button"
                                onClick={closeModal}
                                disabled={isLoading}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                type="button"
                                isLoading={isLoading}
                                onClick={handleConfirmMarkAsLost}
                                disabled={isLoading}
                            >
                                Bestätigen
                            </Button>
                        </>
                    }
                >
                    <ModalTitle>
                        Bestätigen Sie den Verlust des Führerscheins
                    </ModalTitle>
                    <WarningMessage>
                        <WarningRounded />
                        Die Führerscheinkontrolle wird deaktiviert!
                    </WarningMessage>
                </Modal>
            )}
        </>
    );
};

MarkAsLostButton.propTypes = {
    driverLicenseControl: PropTypes.object.isRequired,
};

export default MarkAsLostButton;
